import { lazy } from 'react';

const Sider = lazy(() => import('./Sider'));

export { Sider };
